export default __webpack_public_path__ + "static/V-YLI_Ylivalotus-0dd222a7046adccfc99d8f3fdc4d3c39.jpg";